import SvgIcon, { SvgIconProps } from '../components/SvgIcon';

interface Props extends SvgIconProps {}

const PlayIcon = ({ ...props }: Props) => {
  return (
    <SvgIcon
      width={33}
      height={33}
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.5001 3.1665C13.863 3.1665 11.2851 3.94849 9.09248 5.41358C6.89983 6.87866 5.19086 8.96104 4.18169 11.3974C3.17253 13.8337 2.90848 16.5146 3.42295 19.101C3.93742 21.6875 5.2073 24.0632 7.072 25.9279C8.9367 27.7926 11.3125 29.0625 13.8989 29.577C16.4853 30.0914 19.1662 29.8274 21.6025 28.8182C24.0389 27.8091 26.1213 26.1001 27.5863 23.9074C29.0514 21.7148 29.8334 19.1369 29.8334 16.4998C29.8334 14.7489 29.4885 13.0151 28.8185 11.3974C28.1484 9.77972 27.1663 8.30986 25.9282 7.07175C24.6901 5.83363 23.2202 4.85151 21.6025 4.18144C19.9849 3.51138 18.251 3.1665 16.5001 3.1665ZM16.5001 27.1665C14.3904 27.1665 12.3281 26.5409 10.574 25.3688C8.81988 24.1968 7.45271 22.5309 6.64537 20.5818C5.83804 18.6327 5.6268 16.488 6.03838 14.4189C6.44995 12.3497 7.46585 10.4491 8.95761 8.95737C10.4494 7.4656 12.35 6.4497 14.4191 6.03813C16.4883 5.62655 18.633 5.83779 20.582 6.64512C22.5311 7.45246 24.197 8.81963 25.3691 10.5738C26.5412 12.3279 27.1668 14.3902 27.1668 16.4998C27.1668 19.3288 26.0429 22.0419 24.0426 24.0423C22.0422 26.0427 19.3291 27.1665 16.5001 27.1665Z"
        fill="currentColor"
      />
      <path
        d="M16.9534 10.4332C16.6267 10.1321 16.2187 9.93367 15.7802 9.86255C15.3416 9.79144 14.8919 9.85077 14.4868 10.0332C14.0935 10.1923 13.7566 10.465 13.5191 10.8165C13.2816 11.168 13.1543 11.5823 13.1534 12.0065V20.9932C13.1543 21.4174 13.2816 21.8317 13.5191 22.1832C13.7566 22.5347 14.0935 22.8074 14.4868 22.9665C14.7758 23.0976 15.0894 23.1658 15.4068 23.1665C15.9786 23.164 16.5294 22.9503 16.9534 22.5665L21.8334 18.0732C22.0517 17.8733 22.226 17.6302 22.3452 17.3594C22.4644 17.0885 22.526 16.7958 22.526 16.4998C22.526 16.2039 22.4644 15.9112 22.3452 15.6403C22.226 15.3695 22.0517 15.1264 21.8334 14.9265L16.9534 10.4332Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default PlayIcon;
